import React, { FC } from 'react';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { ReactFacebookFailureResponse, ReactFacebookLoginInfo } from 'react-facebook-login';
import { TextButton } from '../../../commons/buttons/TextButton';
import { FacebookIcon } from '../../../commons/icons/Facebook';

interface LoginWithFacebookProps {
  handleFacebookLogin: (res: ReactFacebookLoginInfo | ReactFacebookFailureResponse) => void;
}

export const LoginWithFacebook: FC<LoginWithFacebookProps> = ({ handleFacebookLogin }) => {
  return (
    <FacebookLogin
      appId={process.env.REACT_APP_FACEBOOK_CLIENT_ID || ''}
      callback={handleFacebookLogin}
      fields="name,email"
      redirectUri={process.env.REACT_APP_HOME || ''}
      isMobile={false}
      render={(renderProps) => (
        <TextButton
          label={<FacebookIcon className="login-socials__item" />}
          handleClick={renderProps.onClick}
          className="unstyled"
        />
      )}
    />
  );
};
